module.exports = __webpack_public_path__ + "img/039-charging.115cc49a.svg";